import apiClient from "./apiClient";

async function unwrap(promise) {
  const res = await promise;
  return res.data;
}

const portalAccountingApi = {
  listAccounts: () => unwrap(apiClient.get("/api/accounting/accounts")),
  listMappings: () => unwrap(apiClient.get("/api/accounting/mappings")),

  listJournalEntries: ({
    dateFrom,
    dateTo,
    sourceModule,
    sourceId,
    limit = 50,
    offset = 0,
  } = {}) =>
    unwrap(
      apiClient.get("/api/accounting/journal-entries", {
        params: { dateFrom, dateTo, sourceModule, sourceId, limit, offset },
      })
    ),

  // backend expects numeric id (same as admin)
  getJournalEntry: (id) => unwrap(apiClient.get(`/api/accounting/journal-entries/${id}`)),

  getTrialBalance: ({ dateFrom, dateTo } = {}) =>
    unwrap(apiClient.get("/api/accounting/reports/trial-balance", { params: { dateFrom, dateTo } })),

  getPnL: ({ dateFrom, dateTo } = {}) =>
    unwrap(apiClient.get("/api/accounting/reports/pnl", { params: { dateFrom, dateTo } })),

  getTaxSummary: ({ dateFrom, dateTo, branchId } = {}) =>
    unwrap(apiClient.get("/api/accounting/reports/tax-summary", { params: { dateFrom, dateTo, branchId } })),
};

export default portalAccountingApi;
